<template>
	<div class="bgGrey">
		<Header></Header>
		<router-view></router-view>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '../../templates/header'
	import Footer from '../../templates/footer'
	export default {
	    name: 'Home',
	    components: { Header, Footer },
	    data () {
	        return {}
	    },
	    mounted () {
	        // 初始化内容
	
	    },
	    methods: {
	        //页面操作
	    },
	}
</script>

<style>
</style>
